<template>
    <div class="home">
        <Header ref="header" :type='headType'></Header>
        <BanIn url="image005">
            <template v-slot:text>
                <h2 class="inTit f48 wow fadeInLeft">业务与服务</h2>
                <div class="inDes f24 wow fadeInRight">
                    <p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
                </div>
            </template>
        </BanIn>
        <div class="mainBg">
            <div class="breadBg">
                <div class="wrap">
					<div class="breadBox flex align-center justify-between">
                        <ul class="breadNav">
                            <li><router-link to="/">首页</router-link></li>
                            <li><router-link to="/service">业务与服务</router-link></li>
                            <li class="active">{{info.title}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="serBg1">
                <div class="wrap">
                    <div class="ser1Box1">
                        <div class="ser1Img">
                            <img :src="info.image" alt="">
                        </div>
                        <div class="ser1Text">
                            <h3 class="hmTitCn f40 color3">{{info.title}}</h3>
                            <div class="ser1Con f18 color6" v-html="info.info"></div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!-- <div class="ser1Box2">
                        <img src="@/assets/images/service/ser-img.png" alt="">
                    </div> -->
                </div>
            </div>
            <div class="serBg2">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">现代化仓库管理</h2>
                        <div class="hmTitDes f20 color6">
                            <p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
                        </div>
                    </div>
                    <ul class="ser2List flex flex-wrap justify-center">
                        <li class="wow zoomIn" v-for="(item, index) in info.content" :key="index">
                            <div class="ser2Item">
                                <div class="ser2Con flex-center">
                                    <div class="ser2Icon">
                                        <img :src="iconList[index%4].icon" alt="">
                                    </div>
                                    <div class="ser2Text f18 color6 MultiLine">
                                        <div class="ser2Des">
                                            <p>{{item.value_1}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import BanIn from '@/components/BanIn.vue'
import Footer from '@/components/Footer.vue'
import { WOW } from 'wowjs'
import home from '@/api/home'
export default {
    name: 'ServiceDetail',
    components: {
        Header,
        BanIn,
        Footer
    },
    data() {
        return {
            headType:3,
            id:"",
			info:'',
            iconList:[
                { icon: require('@/assets/images/service/ser2-icon1.png')},
                { icon: require('@/assets/images/service/ser2-icon2.png')},
                { icon: require('@/assets/images/service/ser2-icon3.png')},
                { icon: require('@/assets/images/service/ser2-icon4.png')}
            ]
        }
    },
    watch: {
        '$route' () {
            this.getData(this.$route.query.id)
        }
    },
    computed: {
        
    },

    created() {
    },
    mounted () {
        this.$nextTick(()=>{
            new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()            

            // // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
            // this.$nextTick(() => {
            //   this.$wow.sync();
            // });
        });
        this.id = this.$route.query.id;
		this.getData(this.id);
    },
    methods: {
        getData(id){            
            this.id = id;		
			home.serInfo({id:this.id}).then((res)=>{
				if (res.code === 1) {
					console.log(res)
					this.info = res.data
				} else {
					this.$toast(res.msg)
				}
			});
        },
    },
    destroyed(){
        
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/css/service.scss';
</style>